import * as React from 'react'
import {ConstrImportInputDataControl} from './ConstrImportInputDataControl'
import {ConstrImportConnectValidations} from './ConstrImportConnectValidations'
import {ConstrImportAction} from './ConstrImportAction'

export const EditsImportControl = () => {
  return (
    <div style={{overflow: 'auto', height: '100%'}}>
      <ConstrImportInputDataControl />
      <ConstrImportConnectValidations />
      <ConstrImportAction />
    </div>
  )
}
